import { combineEpics } from "redux-observable";
import dataEpic from "./data";

import loggingEpic from "./logger";

export default combineEpics(dataEpic, loggingEpic);
